module.exports = __webpack_public_path__ + "img/festive-stamp.8603d24.svg";